module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "fore"
    }
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "tnis"
  }, [_vm._v("I was brought up with dogs and have always found them comical as well as very lovable. About a year ago, I started drawing cartoons featuring talking dogs and was encouraged by friends to put them on a social media site. I then created an "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Off The Leash")]), _vm._v(" Facebook page and started posting one a day. I was amazed by the response and now have many thousands of people following the cartoons every day, all over the world. The cartoons appeal to all sorts of people, from passionate dog lovers who have eight sleeping on their bed at night, to people who don’t have any pets at all, but can still identify with the characteristics. Let’s face it, who doesn’t like to be fed, have their tummy stroked and snooze on the sofa in the afternoon? This is my first "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Off The Leash")]), _vm._v(" compilation — I hope you enjoy it!")]), _vm._v(" "), _c('p', {
    staticClass: "ausig"
  }, [_vm._v("Rupert Fawcett")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f05f049","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/foreword.vue
// module id = 72
// module chunks = 0